import React, { useState } from "react";
import { auth, db } from "../firebase/firebaseConfig";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const RegisterNewUser = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [isAdmin, setIsAdmin] = useState(false); // ✅ nový stav

  const navigate = useNavigate();

  const handleRegister = async () => {
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const createdUser = userCredential.user;

      await setDoc(doc(db, "users", createdUser.uid), {
        name,
        email,
        isAdmin, // ✅ použijeme checkbox hodnotu
      });

      alert("Uživatel úspěšně vytvořen.");
      setEmail("");
      setName("");
      setPassword("");
      setIsAdmin(false);
    } catch (error) {
      console.error("Chyba při registraci:", error);
      alert("Chyba při registraci: " + error.message);
    }
  };

  return (
    <div className="min-h-screen relative bg-gray-100 flex flex-col items-center justify-center p-4">
      <div className="absolute top-4 right-4">
        <button onClick={() => navigate("/admin")} className="bg-green-600 text-white px-4 py-2 rounded flex items-center gap-1 hover:bg-green-700 transition">
          <ArrowLeft className="w-5 h-5" /> Zpět
        </button>
      </div>

      <div className="bg-white shadow-md rounded px-8 py-6 max-w-md w-full">
        <h2 className="text-2xl font-bold mb-6 text-center">Registrovat nového uživatele</h2>

        <input type="text" placeholder="Jméno" className="w-full border p-2 rounded mb-4" value={name} onChange={(e) => setName(e.target.value)} />

        <input type="email" placeholder="E-mail" className="w-full border p-2 rounded mb-4" value={email} onChange={(e) => setEmail(e.target.value)} />

        <input type="password" placeholder="Heslo" className="w-full border p-2 rounded mb-4" value={password} onChange={(e) => setPassword(e.target.value)} />

        <label className="flex items-center mb-6 text-sm text-gray-700">
          <input type="checkbox" checked={isAdmin} onChange={(e) => setIsAdmin(e.target.checked)} className="mr-2" />
          Admin práva
        </label>

        <button onClick={handleRegister} className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700">
          Registrovat
        </button>
      </div>
    </div>
  );
};

export default RegisterNewUser;
